import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { clearAll } from 'src/redux/registrant';

import vw from 'src/styles/utils';
import media from 'src/styles/media';
import Helmet from 'react-helmet';
import QuestionnaireInput from 'components/Form/elements/QuestionnaireInput';
import Select from 'components/Form/elements/Select';

import Button from 'components/Button';
import { MultiSelectCheckbox } from 'components/Form/elements/MultiSelectCheckbox';

import questionnaireSelection from 'src/data/questionnaireSelection';
import { RadioButtonSection } from '../../components/Form/elements/RadioButtonSection';

const QuestionnaireForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [checkedSections, setCheckedSections] = useState([]);
  const [validCheckboxSections, setValidCheckboxSections] = useState([]);
  const [toThankYou, setToThankYou] = useState(false);
  // const [errorArray, setErrorArray] = useState([]);
  const [errorExists, setErrorExists] = useState(false);

  let history = useHistory();
  var errorMessage = '';

  const emailValidation = (email) => {
    // console.log(email);
    if (email != '') {
      return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
        email
      );
    }
    return true;
    // if (
    //   //eslint-disable-next-line
    //   !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
    //     email
    //   )
    // ) {
    //   missing += '- Realtor email is invalid\r\n';
    //   // missing += ' ';
    // }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setErrorExists(false);

    errorMessage = 'Please answer the following required questions:\r\n';
    setIsLoading(true);

    const forms = document.querySelectorAll('form');
    const form = forms[0];
    let error = 0;

    var customRequired = document.querySelectorAll(
      'input:required, #contactEmail, textarea:required, select:required, [data-required="true"]'
    );

    // console.log(customRequired);

    let errorArray = [];

    for (var i = 0; i < customRequired.length; i++) {
      // required[customRequired[i].id] = customRequired[
      //   i
      // ].parentNode.firstElementChild.innerHTML.replace('*', '');
      //console.log(docCustomRequired.parentNode.classList.add("error"))
      const docCustomRequired = document.getElementById(customRequired[i].id);

      if (
        // (docCustomRequired.type === 'checkbox' &&
        //   !docCustomRequired.checked) ||
        docCustomRequired.value === '' ||
        docCustomRequired.value === '--'
      ) {
        docCustomRequired.parentNode.classList.add('error');
        error += 1;
        setErrorExists(true);
        errorArray.push(
          docCustomRequired.parentNode.firstChild.innerText.replace('*', '')
        );
      } else if (
        docCustomRequired.type === 'radio' &&
        !docCustomRequired.checked
      ) {
        if (checkedSections.includes(docCustomRequired.name)) {
          docCustomRequired.parentNode.parentNode.parentNode.parentNode.firstChild.classList.remove(
            'error'
          );
        } else {
          docCustomRequired.parentNode.parentNode.parentNode.parentNode.firstChild.classList.add(
            'error'
          );
          error += 1;
          setErrorExists(true);
          errorArray.push(docCustomRequired.dataset.question);
          // errorMessage += `- ${
          //   docCustomRequired.dataset.question
          //     ? docCustomRequired.dataset.question
          //     : 'Unknown'
          // }\r\n`;
        }
      } else if (
        docCustomRequired.type === 'checkbox' &&
        !validCheckboxSections.includes(docCustomRequired.dataset.id)
      ) {
        if (!errorArray.includes(docCustomRequired.dataset.question))
          errorArray.push(docCustomRequired.dataset.question);
        docCustomRequired.parentNode.parentNode.parentNode.firstChild.classList.add(
          'error'
        );
        error += 1;
        setErrorExists(true);
        // errorMessage += `- ${
        //   docCustomRequired.dataset.id
        //     ? docCustomRequired.dataset.id
        //     : 'Unknown'
        // }\r\n`;
      } else {
        docCustomRequired.parentNode.parentNode.parentNode.firstChild.classList.remove(
          'error'
        );
      }
    }

    if (
      !emailValidation(document.querySelector('#contactEmail').value) ||
      !document.querySelector('#contactEmail').value
    ) {
      document.querySelector('#contactEmail').parentNode.classList.add('error');
      error += 1;
      setErrorExists(true);

      errorMessage += '- Email is invalid\r\n';
    } else {
      document
        .querySelector('#contactEmail')
        .parentNode.classList.remove('error');
    }

    const formData = new FormData();

    Array.from(form.elements).forEach((input) => {
      // console.log(
      //   input.type +
      //     ': ' +
      //     input.dataset.title +
      //     input.name +
      //     '====' +
      //     input.value
      // );
      // console.log(input.checked);
      if (input.checked) {
        formData.append(input.name, input.value);
        // console.log(`>`, input.name, input.value);

        // console.log(
        //   `Name: ${input.name}`,
        //   `\nValue: ${input.value}`,
        //   `\nPriority: ${input.dataset.priority}\n\n` // input.dataset.priority is basically the priority number at the end of the name
        // );
      } else if (input.name !== '' && input.type === 'text') {
        formData.append(input.name, input.value);
        // console.log(`>`, input.name, input.value);

        // console.log(`Name: ${input.name}`, `\nValue: ${input.value}\n\n`);
      }
    });

    if (error === 0) {
      const response = await fetch(
        'https://hook.integromat.com/bd945obkegn3dmttxeehqk6jh4xeaavl',
        {
          method: 'POST',
          body: formData,
        }
      );
      const responseJson = await response.json();

      // console.log(responseJson);

      if (responseJson.status === 'Success') {
        // redirect is changed to a better way at line 203
        setToThankYou(true);
      }
    } else {
      errorMessage += errorArray.map((error) => `- ${error}`).join(`\r\n`);
      // alert(errorMessage);

      // console log each formdata
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }
    }
    setIsLoading(false);
  };

  // Once user submits the form and the submit is a success, user is redirected to the thank you page.
  if (toThankYou === true) {
    return <Redirect to="/questionnaire-thankyou" />;
  }

  return (
    <Root>
      <Loading active={isLoading} />
      <Helmet
        meta={[
          {
            name: 'robots',
            content: 'noindex,nofollow',
          },
        ]}
      />
      <Logo src={require('src/assets/images/logo.svg')} alt="logo" />

      <h1>Homebuyer Questionnaire</h1>
      <h3>The Amazing Brentwood - Neighbourhood Two – Tower 5</h3>

      <Fields>
        <QuestionnaireInput
          type="text"
          label="First Name*"
          id="contactFirstName"
          class="block"
          required
          questionnaire
        />
        <QuestionnaireInput
          type="text"
          label="Last Name*"
          id="contactLastName"
          class="block"
          required
          questionnaire
        />
        <QuestionnaireInput
          label="Email Address*"
          id="contactEmail"
          class="block"
          type="text"
          required
          questionnaire
        />
        <QuestionnaireInput
          label="Unit Number*"
          id="UnitNumber"
          class="block"
          required
          questionnaire
        />
        <QuestionnaireInput
          label="Strata Lot*"
          id="StrataLot"
          class="block"
          required
          questionnaire
        />
      </Fields>

      <p>
        Congratulations on purchasing a home in Tower 5 at The Amazing Brentwood
        and becoming an integral part of Metro Vancouver’s most celebrated urban
        destination.
      </p>

      <p>
        We greatly value your input as we continue to develop and design The
        Amazing Brentwood. Your feedback will directly influence the improvement
        of the master plan and design efforts as The Amazing Brentwood continues
        to evolve. Once the survey is complete, and your deposit is paid, you
        may pick up your $50 Gift Card to The Amazing Brentwood at our
        Presentation Centre (#301-4567 Lougheed Hwy.). Only 1 Gift Card per home
        purchase.
      </p>

      <p>
        <strong>
          Your information and answers are for general data purposes only, and
          will be kept confidential.
        </strong>
      </p>
      <br />
      <FormSection>
        <h3>REASON FOR PURCHASE:</h3>
        {/* Removed the enclosing Fields component for now, it was breaking the grid */}

        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          mustMax={3}
          data={questionnaireSelection.top3CriteriaToPurchase.options}
          maxSelect={3}
          title={questionnaireSelection.top3CriteriaToPurchase.title}
          name={questionnaireSelection.top3CriteriaToPurchase.id}
        />

        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.top3FeaturesToPurchase.options}
          maxSelect={3}
          mustMax={3}
          title={questionnaireSelection.top3FeaturesToPurchase.title}
          name={questionnaireSelection.top3FeaturesToPurchase.id}
        />

        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.reasonToPurchase.options}
          title={questionnaireSelection.reasonToPurchase.title}
          name={questionnaireSelection.reasonToPurchase.id}
          abstract
        />
      </FormSection>

      {/* Radio Example */}
      <FormSection>
        <h3>LIFESTYLE</h3>
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.top3Groceries.options}
          maxSelect={3}
          mustMax={3}
          title={questionnaireSelection.top3Groceries.title}
          name={questionnaireSelection.top3Groceries.id}
          other
          // Please do the necessary styling via css/styled-components.
          // ":" is added via the MultiSelectCheckbox component now, no need to add it as a prop.
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          key={0}
          data={questionnaireSelection.groceriesDeliverFrequency.options}
          title={questionnaireSelection.groceriesDeliverFrequency.title}
          name={questionnaireSelection.groceriesDeliverFrequency.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          key={1}
          data={questionnaireSelection.dineOutFrequency.options}
          title={questionnaireSelection.dineOutFrequency.title}
          name={questionnaireSelection.dineOutFrequency.id}
        />
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.top3RestaurantType.options}
          maxSelect={3}
          mustMax={3}
          title={questionnaireSelection.top3RestaurantType.title}
          name={questionnaireSelection.top3RestaurantType.id}
          other
          otherText="Other (Specific Type or Name of Restaurant)"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.deliveryFrequency.options}
          title={questionnaireSelection.deliveryFrequency.title}
          name={questionnaireSelection.deliveryFrequency.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.primaryTransportation.options}
          title={questionnaireSelection.primaryTransportation.title}
          other
          // otherText prop is not required, if other prop is passed, otherText is "Other" by default. Same with MultiSelectCheckbox.
          otherText="Other"
          name={questionnaireSelection.primaryTransportation.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.cityOfEmployment.options}
          title={questionnaireSelection.cityOfEmployment.title}
          other
          // otherText prop is not required, if other prop is passed, otherText is "Other" by default. Same with MultiSelectCheckbox.
          otherText="Other"
          name={questionnaireSelection.cityOfEmployment.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.technologyUpToDate.options}
          title={questionnaireSelection.technologyUpToDate.title}
          name={questionnaireSelection.technologyUpToDate.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.patioFrequency.options}
          title={questionnaireSelection.patioFrequency.title}
          name={questionnaireSelection.patioFrequency.id}
        />
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.patioUsage.options}
          title={questionnaireSelection.patioUsage.title}
          name={questionnaireSelection.patioUsage.id}
          other
          otherText="Other"
        />
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.storageUsage.options}
          title={questionnaireSelection.storageUsage.title}
          name={questionnaireSelection.storageUsage.id}
          other
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.conciergeImportant.options}
          title={questionnaireSelection.conciergeImportant.title}
          name={questionnaireSelection.conciergeImportant.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.withoutParking.options}
          title={questionnaireSelection.withoutParking.title}
          name={questionnaireSelection.withoutParking.id}
          abstract
        />

        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.top3Social.options}
          mustMax={3}
          maxSelect={3}
          title={questionnaireSelection.top3Social.title}
          name={questionnaireSelection.top3Social.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.rentalMarketImpact.options}
          title={questionnaireSelection.rentalMarketImpact.title}
          name={questionnaireSelection.rentalMarketImpact.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.rentAtAmazing.options}
          title={questionnaireSelection.rentAtAmazing.title}
          name={questionnaireSelection.rentAtAmazing.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.ownAtAmazing.options}
          title={questionnaireSelection.ownAtAmazing.title}
          name={questionnaireSelection.ownAtAmazing.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.primarilyPurcahseFor.options}
          title={questionnaireSelection.primarilyPurcahseFor.title}
          name={questionnaireSelection.primarilyPurcahseFor.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.numberOfInvestmentProperties.options}
          title={questionnaireSelection.numberOfInvestmentProperties.title}
          name={questionnaireSelection.numberOfInvestmentProperties.id}
        />
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.primarilyPortfolio.options}
          maxSelect={3}
          mustMax={3}
          title={questionnaireSelection.primarilyPortfolio.title}
          name={questionnaireSelection.primarilyPortfolio.id}
          other
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.mortgageHome.options}
          title={questionnaireSelection.mortgageHome.title}
          name={questionnaireSelection.mortgageHome.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.downpaymentSource.options}
          title={questionnaireSelection.downpaymentSource.title}
          name={questionnaireSelection.downpaymentSource.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.anotherHomeIn12Month.options}
          title={questionnaireSelection.anotherHomeIn12Month.title}
          name={questionnaireSelection.anotherHomeIn12Month.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.completionLengthBenefit.options}
          title={questionnaireSelection.completionLengthBenefit.title}
          name={questionnaireSelection.completionLengthBenefit.id}
          abstract
        />
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.top3ResaleVSPresale.options}
          maxSelect={3}
          mustMax={3}
          title={questionnaireSelection.top3ResaleVSPresale.title}
          name={questionnaireSelection.top3ResaleVSPresale.id}
          other
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.firstPurcahse.options}
          title={questionnaireSelection.firstPurcahse.title}
          name={questionnaireSelection.firstPurcahse.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.purchasedBurnaby.options}
          title={questionnaireSelection.purchasedBurnaby.title}
          name={questionnaireSelection.purchasedBurnaby.id}
          abstract
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.householdIncome.options}
          title={questionnaireSelection.householdIncome.title}
          name={questionnaireSelection.householdIncome.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.typeOfHomeCurrent.options}
          title={questionnaireSelection.typeOfHomeCurrent.title}
          name={questionnaireSelection.typeOfHomeCurrent.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.primarilyFinancialInstitution.options}
          title={questionnaireSelection.primarilyFinancialInstitution.title}
          name={questionnaireSelection.primarilyFinancialInstitution.id}
          other
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          data={questionnaireSelection.languageAtHome.options}
          title={questionnaireSelection.languageAtHome.title}
          name={questionnaireSelection.languageAtHome.id}
          other
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.childrenCount.options}
          title={questionnaireSelection.childrenCount.title}
          name={questionnaireSelection.childrenCount.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.childPlayAmenities.options}
          title={questionnaireSelection.childPlayAmenities.title}
          name={questionnaireSelection.childPlayAmenities.id}
        />
        <MultiSelectCheckbox
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          validCheckboxSections={validCheckboxSections}
          setValidCheckboxSections={setValidCheckboxSections}
          required
          data={questionnaireSelection.projectHeard.options}
          title={questionnaireSelection.projectHeard.title}
          name={questionnaireSelection.projectHeard.id}
          other
          otherText="Other"
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.shapeQaulityPerception.options}
          title={questionnaireSelection.shapeQaulityPerception.title}
          name={questionnaireSelection.shapeQaulityPerception.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.shapeReputationImpact.options}
          title={questionnaireSelection.shapeReputationImpact.title}
          name={questionnaireSelection.shapeReputationImpact.id}
        />
      </FormSection>
      <FormSection>
        <h3>FUTURE DEVELOPMENT</h3>
        <Fields>
          <QuestionnaireInput
            label="HOW HAS COVID IMPACTED YOUR HOME DECISION?"
            id="covidImpact"
            class="block"
            questionnaire
          />
        </Fields>
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.frenquencyWorkFromHome.options}
          title={questionnaireSelection.frenquencyWorkFromHome.title}
          name={questionnaireSelection.frenquencyWorkFromHome.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.workpaceAtHome.options}
          title={questionnaireSelection.workpaceAtHome.title}
          name={questionnaireSelection.workpaceAtHome.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.officeAtHome.options}
          title={questionnaireSelection.officeAtHome.title}
          name={questionnaireSelection.officeAtHome.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.coWorkingAtHome.options}
          title={questionnaireSelection.coWorkingAtHome.title}
          name={questionnaireSelection.coWorkingAtHome.id}
        />
        <RadioButtonSection
          checkedSections={checkedSections}
          setCheckedSections={setCheckedSections}
          abstract
          data={questionnaireSelection.purchaseExperience.options}
          title={questionnaireSelection.purchaseExperience.title}
          name={questionnaireSelection.purchaseExperience.id}
        />

        <Fields>
          <QuestionnaireInput
            label="Any Additional Feedback:"
            id="AdditionalFeedback"
            class="block"
            questionnaire
          />
        </Fields>
        {/* <br />
        <p>
          WHAT OTHER STORES, RESTAURANTS OR SERVICES WOULD YOU LIKE TO SEE AT
          THE AMAZING BRENTWOOD?
        </p>
        <Fields>
          <QuestionnaireInput label="Stores:" id="StoresWouldLikeToSee" class="block" />
          <QuestionnaireInput
            label="Restaurants:"
            id="RestaurantsWouldLikeToSee"
            class="block"
          />
          <QuestionnaireInput label="Services:" id="ServicesWouldLikeToSee" class="block" />
        </Fields> */}
      </FormSection>

      <p></p>
      <p>
        <strong>* indicates required field.</strong>
      </p>
      <Button
        text="Submit"
        handleClick={(e) => handleFormSubmit(e)}
        // isSubmitting={isSubmitting}
      />
      <br />
      <br />
      {errorExists ? (
        <p style={{ color: 'red' }}>
          Please answer the required questions highlighted in red.
        </p>
      ) : null}

      <p></p>
      <p>
        The information contained herein is subject to change without notice.
        Please see a representative from The Amazing Brentwood for more details.
        This is not an offering for sale. E.&O.E.
      </p>
      <p>
        <a href="https://theamazingbrentwood.com/privacy/" target="_blank">
          Click here
        </a>{' '}
        to view SHAPE’s Privacy Policy which governs the collection, use and
        disclosure of your personal information.
      </p>
      {/* <Form email={email} formType="PC" /> */}
    </Root>
  );
};

const Root = styled.form`
  background-color: #dad9d7;
  ${vw('padding-top', 42, 75, 122)};
  ${vw('padding-bottom', 66, 99, 105)};
  ${vw('padding-left', 25, 60, 100)};
  ${vw('padding-right', 25, 60, 200)};
  h1 {
    /* font-family: Gotham Black; */
    font-family: proxima-nova, sans-serif;
    ${vw('font-size', 20, 50)}
    ${vw('padding-bottom', 10, 75, 20)}
  }
  h3 {
    /* font-family: Gotham Medium; */
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    ${vw('font-size', 14, 25)}
    ${vw('padding-bottom', 30, 75, 40)}
  ${vw('padding-right', 0, 60, 200)}
  }
  p {
    /* font-family: Big Caslon; */
    font-family: proxima-nova, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    /* text-transform: none; */
    ${vw('font-size', 14, 16)}
    ${vw('line-height', 22, 22)}
    ${vw('margin-bottom', 22, 20)}
  }
  span {
    color: #de5647;
  }
  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  li {
    /* font-family: Big Caslon; */
    font-family: proxima-nova, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-transform: none;
    ${vw('font-size', 14, 16)}
    ${vw('line-height', 22, 32)}
  }
  div.error label,
  label.error {
    color: red;
  }
  .error p {
    color: red;
  }
  div.error input,
  div.error select {
    border: solid 1px red;
  }
  a {
    color: #de5647;
  }
`;
const FormSection = styled.div`
  border-top: solid 1px #000;
  /* border-bottom: solid 1px #000; */

  opacity: ${(props) => (props.hide ? '0' : '1')};
  height: ${(props) => props.hide && '0'};
  pointer-events: ${(props) => props.hide && 'none'};

  ${(props) =>
    !props.hide &&
    `
      ${vw('padding-top', 22, 40)}
      ${vw('padding-bottom', 22, 0)}
    `}
`;
const Fields = styled.div`
  display: block;

  /* grid-template-areas: 
  "isWorkingWithRealtor isWorkingWithRealtorEmail"
      "buyInfoFile"; */

  .singleRow {
    grid-column: 1 / span 2;
    label {
      margin: 0;
      ${vw('margin-bottom', 22, 40)}
    }
  }
  .doc-guide {
    width: 100%;
  }
  input,
  select {
    display: block;
    ${vw('margin-bottom', 22, 30)}
    background-color: #FFF;
  }

  label {
    ${vw('margin-bottom', 5, 10)}
  }

  div.error label,
  label.error {
    color: red;
  }
  div.error input,
  div.error select {
    border: solid 1px red;
  }

  @media ${media.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 2rem;
  }
  @media ${media.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 2rem;
  }
`;

const Logo = styled.img`
  position: relative;
  ${vw('top', -350, 0, 0)}
  ${vw('left', 0, 0, 0)}
  ${vw('width', 80, 126)}
  ${vw('height', 0, 221)}
  @media ${media.desktop} {
    position: absolute;
    left: unset;
    ${vw('right', 25, 0, 100)}
  }
`;
const Loading = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  background-image: url(${require('src/assets/images/loading.gif')});
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 0.8;
`;

export default QuestionnaireForm;
